<template>
  <page :head-text="headText" :can-scroll="true">
    <template #leftBtn>
      <scan-code v-if="!tempAccess" @click="launchQrScan" />
    </template>
    <template #rightBtn>
      <show-menu @click="$emit('menu')" />
    </template>
    <div v-if="!noRecord" class="flex flex-col h-full mt-12 mb-32">
      <slider @mounted="initSlider">
        <slide v-if="latestBodyRecord">
          <measurement-card
            :record="latestBodyRecord"
            :is-mobile-scan="!latestBodyRecord.provider"
            @click="showRecord"
            @ready="onReady('body')"
          />
        </slide>
        <slide v-if="latestFeetRecord">
          <measurement-card
            :record="latestFeetRecord"
            @click="showRecord"
            @ready="onReady('feet')"
          />
        </slide>
      </slider>
      <img
        v-if="!tempAccess"
        class="mx-auto my-3 start-scan"
        src="@/assets/common/start-scan.svg"
        alt="scan"
        @click="$emit('scan')"
      />
      <div class="text-center scan_text">{{ $t('homePage.tap_to_scan') }}</div>
    </div>
    <first-scan v-else @scan="$emit('scan')" />
    <bottom-nav
      :fixed="true"
      :active-page="activePage"
      @changed="$emit('update:active-page', $event)"
    />
  </page>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import { wait } from '@/modules/utils';
import hasSlider from '@/mixins/has-slider2';
import page from '@/mixins/page';
import Page from '@/components/DefaultCloudzet/HomePage/Page.vue';
import MeasurementCard from '@/components/DefaultCloudzet/HomePage/MeasurementCard.vue';
import FirstScan from '@/components/DefaultCloudzet/HomePage/FirstScan.vue';
import BottomNav from '@/components/DefaultCloudzet/HomePage/BottomNav.vue';
import Slider from '@/components/common/Slider.vue';
import Slide from '@/components/common/Slide.vue';
import ScanCode from '@/components/common/ScanCode.vue';
import ShowMenu from '@/components/common/ShowMenu.vue';

export default {
  name: 'Measurement',
  mixins: [page, hasSlider],
  components: {
    ScanCode,
    ShowMenu,
    FirstScan,
    BottomNav,
    Page,
    MeasurementCard,
    Slider,
    Slide,
  },
  props: {
    recordToShow: Boolean,
    hasRmdSizes: Boolean,
    tempAccess: Boolean,
    activePage: {
      type: String,
      default: 'measurement',
    },
  },
  data: () => ({
    toLoad: new Set(),
    loaded: new Set(),
    allReady: false,
  }),
  methods: {
    ...mapActions('app', ['launchQrScan']),
    showRecord(record) {
      this.$emit('show-record', record);
    },
    async onReady(type) {
      this.loaded.add(type);
      await this.resetSlider();
      if (this.loaded.size === this.toLoad.size) {
        this.ready();
      }
    },
    ready() {
      console.log('measurement view ready');
      this.allReady = true;
      this.$emit('ready');
    },
  },
  computed: {
    ...mapState('user', ['isFetchingRecords', 'feetObjUrl', 'objUrl', 'mobileScanObjUrl']),
    ...mapGetters('user', ['latestBodyRecord', 'latestFeetRecord', 'noRecord']),
    headText() {
      return this.noRecord ? '' : this.$t('homePage.measurement');
    },
  },
  watch: {
    activePage: {
      handler(nv) {
        if (nv === 'measurement') {
          this.resetSlider();
        }
      },
    },
    isFetchingRecords: {
      async handler(nv, ov) {
        if (!nv && ov) {
          if (this.noRecord) {
            this.ready();
            return;
          }
          // NOTE: eventually emit the ready event otherwise the loading UI would show forever
          await wait(8);
          if (!this.allReady) {
            console.log('timeout waiting for measurements to load');
            this.ready();
          }
        }
      },
      immediate: true,
    },
    latestBodyRecord: {
      handler(nv) {
        if (nv) {
          this.toLoad.add('body');
        }
      },
      immediate: true,
    },
    latestFeetRecord: {
      handler(nv) {
        if (nv) {
          this.toLoad.add('feet');
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.head {
  @screen md {
    width: 87%;
  }
}
.start-scan {
  width: 52px;
}
.splide {
  height: 100%;
}
.splide__slide {
  // box-shadow: none;
  box-shadow: 0px 2px 12px rgba(67, 78, 108, 0.5);
  border: 1px solid #ffffff;
  border-bottom: none;
  border-radius: 15px;
  margin-top: 16px;
  & > * {
    height: 100%;
  }
}
.scan_text {
  font-size: 12px;
  background: var(--brand-gradient-light);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  padding-bottom: 1rem;
}
</style>
